<template>
  <div>
    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>
          </v-icon>
          {{ $t('display/emergency:title') }}
        </h2>
        <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="preview"
          @clickedButton1="showJson"
          @updateTableData="updateTable"
          :addBtn="false"
          sortBy="emergencyStart"
          sort-desc
          :trueFalseDecorateFields="['status']"
        />
      </v-col>
    </v-row>
    <DetailWindow
      ref="detailInfo" />
  </div>
</template>

<script>

import DataTablePaginated from '@/modules/core/components/DataTable/DataTablePaginated';
import EmergencyService from '@/modules/display/services/emergency-service';
import DataUtils from '@/modules/core/services/data-utils';
import Utils from '@/modules/core/services/utils';
import Emergency from '@/modules/display/data/emergency';
import DetailWindow from "./DetailWindow";

export default {
  name: "EmergencyOverview",
  components: {
    DetailWindow,
    DataTablePaginated
  },
  data() {
    return {

    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('common:date'), value: 'emergencyStart' },
        { text: this.$t('common:name'), value: 'elevator.name' },
        { text: this.$t('common:street'), value: 'elevator.address' },
        { text: this.$t('common:city'), value: 'elevator.city' },
        { text: this.$t('common:country'), value: 'elevator.country.name' },
        { text: this.$t('common:status'), value: 'status' },
        { text: "", value: "controls", sortable: false }
      ]
    }
  },
  methods: {
    showJson(item) {
      this.$refs.detailInfo.initialization(item);
    },
    updateTable(options, search) {
      if (!search) search = '';

      this.$refs.table.loading = true;

      EmergencyService.readAllPaginatedFromAPI(
        options.page - 1,
        options.itemsPerPage,
        search,
        options.sortBy,
        options.sortDesc,
        (response) => {
          if (this.$refs.table !== undefined) {
            response.data.content = DataUtils.parseDataToObjectArray(response.data.content, Emergency);
            this.$refs.table.fillTableData(response.data);
          }
          this.$refs.table.loading = false;
        },
        () => {
          this.$refs.table.loading = false;
          Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('display/emergency:title')}));
        }
      );
    }
  }
}
</script>
